import { Box, ButtonBase, Icon } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { useContext } from 'react';
import { infoList } from '@/lib/utils/DataFormat';
import UserAvatar from '@/components/ui/userAvatar';
import { ConferenceContext } from '@/store';

const holderSmall = {
  flex: 'auto !important',
  flexDirection: 'row-reverse !important',
  padding: '0px !important',
  textAlign: 'right !important',
  alignSelf: 'end !important',
};
const avatarSmall = {
  paddingRight: '8px !important',
  paddingLeft: '8px !important',
  '&>*': {
    width: '30px !important',
    height: '30px !important',
  },
};

const itemStyles = (theme) => ({
  userHolder: ({ alwaysSmall }) => ({
    flex: '120px 0 0 !important',
    overflow: 'hidden !important',
    padding: '0 8px 8px 0 !important',
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    textAlign: 'center !important',
    [`${theme.breakpoints.down('sm')}`]: holderSmall,
    ...(alwaysSmall ? holderSmall : null),
    '&:hover': {
      backgroundColor: `${theme.palette.background.shadedown_20} !important`,
    },
  }),
  avatar: ({ alwaysSmall }) => ({
    paddingBottom: '5px !important',
    [`${theme.breakpoints.down('sm')}`]: avatarSmall,
    ...(alwaysSmall ? avatarSmall : null),
  }),
  userName: {
    //textDecoration: 'underline',
  },
  infoList: {
    opacity: '0.6 !important',
  },
});

export const DiscussionVisitor = (props) => {
  const theme = useTheme();
  const classes = itemStyles(theme, { alwaysSmall: props.alwaysSmall });
  const { openUserPopup } = useContext(ConferenceContext);

  return props.anonymous ? (
    <Box align="center" sx={classes.userHolder}>
      <Icon fontSize="large">help</Icon>
    </Box>
  ) : props.visitor ? (
    <ButtonBase
      onClick={() => openUserPopup(props.visitor)}
      sx={classes.userHolder}
    >
      <Box sx={classes.avatar}>
        <UserAvatar user={props.visitor} />
      </Box>
      <Box>
        <Box sx={classes.userName}>{props.visitor.full_name}</Box>
        <Box sx={classes.infoList}>
          {infoList([props.visitor.company, props.visitor.location_city])}
        </Box>
      </Box>
    </ButtonBase>
  ) : (
    <Box align="center" sx={classes.userHolder}>
      Participant no longer exist
    </Box>
  );
};

DiscussionVisitor.displayName = 'DiscussionVisitor';
